var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.fileInfo.type === 'image' && 'w-100',attrs:{"src":_vm.src,"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }